export default "__VITE_ASSET__t0BheGOD__"